import { SettingsBusinessesTable } from "./SettingsBusinessesTable";
import { PulseLoader } from "react-spinners";
import { useGetBusinesses } from "@/hooks/useGetBusinesses";
import * as Sentry from "@sentry/react";

export function SettingsBusinesses() {
  const businesses = useGetBusinesses();

  if (businesses.isLoading) {
    return (
      <div className="flex justify-center items-center pt-20">
        <PulseLoader color="lightgray" loading={true} size={15} speedMultiplier={0.6} />
      </div>
    );
  }

  if (!businesses.isSuccess) {
    Sentry.captureException(businesses.error, {
      extra: {
        message: "businesses.isSuccess is false",
        extra: {
          error: businesses.error,
        },
      },
    });
    // TODO(yannis): show something
    return null;
  }

  return <SettingsBusinessesTable businesses={businesses.data} />;
}
